export const amazon = {
  authSuccess: "Seller Central app was successfully authorized",
  oAuthFlowHelp: "Authorize Amazon Seller Central app",
  region: "Seller Central Region",
  migrationSuccess: "Successfully acquired token from Amazon.",
  activateReceiptTitle: "Activate invoice service?",
  activateReceiptIntro:
    "From the next save onwards, Xentral automatically creates and synchronizes invoices with your sales channel.",
  activateReceiptConfirm:
    "Confirm that you have deactivated the invoice service in the old shop importer (legacy).",
  activateReceiptWarning:
    "If it stays active in both places, duplicate or incorrect invoices will be created.",
  activateReceiptInstruction:
    "How to deactivate the invoice service in the old shop importer: set the invoice handling to None/Amainvoice.",
  activateReceiptOpenLegacy: "Open the old shop importer",
  activateReceiptOpenHandbook: "View the handbook guide",
  activateReceiptHandbookUrl:
    "https://help.xentral.com/hc/en-us/articles/25769333725596-Amazon-Workflows-konfigurieren",
  activateReceiptChecking: "Checking the status of the old shop importer …",
  activateReceiptLegacyStillActive:
    "The old shop importer (sales channel) is still active. Deactivate it first before activating the invoice service.",
  activateReceiptCheckFailed:
    "Could not check the status of the old shop importer. Please try again."
};
